
import DashboardLayout from "@/components/DashboardLayout";
import ProductsMainContent from "@/components/ProductsMainContent";
import DemoPageHeader from "@/components/DemoPageHeader";
import { DEMO_PRODUCTS } from "@/utils/demoData";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const DemoProducts = () => {
  return (
    <DashboardLayout>
      <DemoPageHeader
        title="Demo Products"
        description="Experience how you would manage your Etsy product inventory."
      >
        {/* Demo Banner */}
        <Card className="border-blue-200 bg-blue-50 mb-6">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <Sparkles className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="flex-1">
                <h3 className="font-semibold text-blue-900 mb-1">Demo Product Management</h3>
                <p className="text-blue-800 text-sm mb-3">
                  Explore {DEMO_PRODUCTS.length} sample products with real sales data, inventory tracking, 
                  and performance metrics. See how you would monitor your actual product performance.
                </p>
                <Link to="/signup">
                  <Button size="sm" className="bg-blue-600 hover:bg-blue-700">
                    Connect Your Real Products
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>

        <ProductsMainContent 
          products={DEMO_PRODUCTS}
          isLoading={false}
          isConnected={true}
          needsOrderSync={false}
        />
      </DemoPageHeader>
    </DashboardLayout>
  );
};

export default DemoProducts;
